import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Zap, Clock, Globe, Sparkles } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';

const WHATSAPP_URL = 'https://wa.me/919663112394?text=Hi!%20I%27m%20interested%20in%20getting%20a%20website%20for%20my%20business';

const HeroSection = () => {
  return (
    <section className="relative pt-28 pb-20 lg:pt-36 lg:pb-28 bg-hero-gradient overflow-hidden" data-testid="hero-section">
      {/* Decorative elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-primary-200/30 rounded-full blur-3xl" />
      <div className="absolute bottom-10 left-10 w-96 h-96 bg-secondary-200/20 rounded-full blur-3xl" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-accent-200/10 rounded-full blur-3xl" />

      <div className="container relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-sm border border-primary-100 text-primary-600 font-medium rounded-full text-sm mb-8 shadow-sm">
              <Sparkles className="w-4 h-4" />
              Trusted by 100+ Indian Businesses
            </span>
          </motion.div>

          <motion.h1
            className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold text-neutral-900 mb-6 leading-[1.08]"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            Professional Websites.{' '}
            <span className="text-gradient-primary">Built in 48 Hours.</span>
          </motion.h1>

          <motion.p
            className="text-lg md:text-xl text-neutral-500 mb-10 max-w-2xl mx-auto leading-relaxed"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            Premium booking sites for salons, clinics & service businesses. 
            Modern design. Lightning-fast delivery. Your domain.
          </motion.p>

          <motion.div
            className="flex flex-wrap justify-center gap-4 mb-16"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <a
              href="#examples"
              className="btn-primary text-base px-8 py-4"
              data-testid="hero-see-examples-btn"
            >
              See Examples
              <ArrowRight className="w-5 h-5" />
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-whatsapp text-base px-8 py-4"
              data-testid="hero-whatsapp-btn"
            >
              <FaWhatsapp className="w-5 h-5" />
              WhatsApp Us
            </a>
          </motion.div>

          {/* Floating feature badges */}
          <motion.div
            className="flex flex-wrap justify-center gap-6 md:gap-10"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.45 }}
          >
            {[
              { icon: Zap, text: 'Live in 48 Hours' },
              { icon: Clock, text: 'From Rs 9,999/mo' },
              { icon: Globe, text: 'Your Own Domain' }
            ].map((badge, i) => (
              <div key={i} className="flex items-center gap-2.5 text-neutral-600">
                <div className="w-9 h-9 rounded-lg bg-white shadow-sm flex items-center justify-center">
                  <badge.icon className="w-4.5 h-4.5 text-primary-500" />
                </div>
                <span className="font-medium text-sm">{badge.text}</span>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
